import defaultRecipeImg from "../assets/default-recipe.png";
import { buildFrontendUrl } from "../config/urls";

export function resolveRecipeImage(imageUrl) {
  if (!imageUrl) return defaultRecipeImg;

  // absolute URLs -> keep
  if (imageUrl.startsWith("http://") || imageUrl.startsWith("https://")) return imageUrl;

  // DB value like "/uploads/recipes/my.jpg" OR "uploads/recipes/my.jpg"
  const clean = String(imageUrl).replace(/^\/+/, ""); // "uploads/recipes/my.jpg"
  return buildFrontendUrl(`/${clean}`);
}
